import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import ProtectedRoute from './routes/ProtectedRoute'
import SuperAdminRoute from './routes/SuperAdminRoute'
import AdminRoute from './routes/AdminRoute'
// import PenulisRoute from './routes/RoleBasedRoute'
import RoleBasedRoute from './routes/RoleBasedRoute'
import SignUpPenulis from './pages/SignUpPenulis'


import Layout from './components/Layout'
// import Login from './pages/Login'
import LoginWrapper from './pages/LoginWrapper'
import Dashboard from './pages/Dashboard'
import HeroSection from './pages/HeroSection'
import StructureSection from './pages/StructureSection'
import ProgramKerja from './pages/ProgramKerja'
import Kegiatan from './pages/Kegiatan'
import Ekskul from './pages/Ekskul'
import Pendaftaran from './pages/Pendaftaran'
import Pengumuman from './pages/Pengumuman'
import KotakSaran from './pages/KotakSaran'
import Settings from './pages/Settings'
import Users from './pages/Users'
import Mading from './pages/Mading'
import SettingsPenulis from './pages/SettingsPenulis'
import AdminMading from './pages/AdminMading'
// import Tutorial from './pages/Tutorial'


import LoadingSpinner from './components/LoadingSpinner'
// import NotFound from './pages/NotFoundPage'

function App() {
  const { loading } = useAuth()

  if (loading) return <LoadingSpinner />

  return (
    <Routes>
      {/* Login */}
      <Route
        path="/login"
        element={<LoginWrapper />}
      />
      <Route path="/signup" element={<SignUpPenulis />} />

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          
          {/* Admin Routes */}
          <Route element={<AdminRoute />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="hero-section" element={<HeroSection />} />
            <Route path="structure" element={<StructureSection />} />
            <Route path="program-kerja" element={<ProgramKerja />} />
            <Route path="kegiatan" element={<Kegiatan />} />
            <Route path="ekskul" element={<Ekskul />} />
            <Route path="pendaftaran" element={<Pendaftaran />} />
            <Route path="pengumuman" element={<Pengumuman />} />
            <Route path="kotak-saran" element={<KotakSaran/>}/>
            <Route path="admin-mading" element={<AdminMading/>} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Super Admin Only */}
          <Route element={<SuperAdminRoute />}>
            <Route path="users" element={<Users />} />
          </Route>

          <Route element={<RoleBasedRoute allowedRoles={['penulis', 'admin', 'super_admin', 'developer']} />}>
            <Route path="mading" element={<Mading />} />
            <Route path="settings-penulis" element={<SettingsPenulis />} />
          </Route>

          {/* 404 fallback dalam protected layout */}
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>
      </Route>

      {/* Coming soon */}
      {/* <Route path='tutorial' element={<Tutorial/>} /> */}

      {/* Global fallback (jika tidak login dan route tidak cocok) */}
      <Route path="*" element={<Navigate to="/login" replace />} />

      
    </Routes>
  )
}

export default App
